module.exports = require('lodash').isEqual